<template>
  <div class="checkout-wrap">
    <emb-page-title :heading="bannerSection.Heading" :image="bannerSection.Image1920x700px"></emb-page-title>
    <div class="section-gap">
      <v-container grid-list-xl py-0>
        <template v-if="cart.length > 0">
          <div class="view-cart mb-12">
            <emb-sidebar-panel></emb-sidebar-panel>
          </div>
          <v-layout row wrap mt-4>
            <v-flex lg6 xl6 xs12 md6 sm12>
              <div class="emb-card pa-6">
                <div>
                  <h4>{{signSection.Sign_In_Title}}</h4>
                  <v-form>
                    <v-text-field
                      required
                      v-model="user"
                      type="text"
                      :placeholder="signSection.Username_Placeholder"
                    ></v-text-field>
                    <v-text-field
                      required
                      type="password"
                      :placeholder="signSection.Password_Placeholder"
                    ></v-text-field>
                    <div class="d-flex align-center justify-space-between">
                      <v-checkbox v-model="checkbox" :label="signSection.Remember_Me_Label"></v-checkbox>
                      <router-link
                        :to="signSection.Forgot_Password_Path"
                        class="text-lg-right mb-1"
                      >{{signSection.Forgot_Password_Label}}</router-link>
                    </div>
                    <v-btn
                      class="accent mb-4 ml-0 mx-0"
                      @click="login"
                    >{{signSection.Sign_In_Button_Label}}</v-btn>
                    <p>
                      {{signSection.Click_Here_Label}}
                      <router-link :to="signSection.Sign_Up_Path">{{signSection.Create_account}}</router-link>
                    </p>
                  </v-form>
                </div>
              </div>
            </v-flex>
            <v-flex lg6 xl6 xs12 md6 sm12>
              <div class="emb-card pa-6">
                <h4>{{signSection.Guest_Checkout_Label}}</h4>
                <p>{{signSection.Title}}</p>
                <v-btn
                  class="accent mt-0 mr-0 mx-0"
                  large
                  :to="signSection.Guest_signin_Button_Path"
                >{{signSection.Guest_signin_Button_Label}}</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </template>
        <template v-else>
          <div class="text-center">
            <div class="mb-6">
              <img alt="cart-empty" height="128" :src="empSection.image_128x128px" width="128" />
            </div>
            <h4>{{empSection.Heading}}.</h4>
            <router-link class="primary--text" to="/">{{empSection.Subtitle1}}</router-link>
          </div>
        </template>
      </v-container>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueSession from "vue-session";
Vue.use(VueSession);
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../services/utils/cms-helper";
export default {
  data() {
    return {
      checkbox: false,
      user: "",
      signSection: "",
      bannerSection: "",
      empSection: "",
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData1();
    this.getPageData2();
  },

  computed: {
    ...mapGetters(["cart"]),
  },
  methods: {
    login() {
      window.location = "http://localhost:8080/checkout/payment";
    },
    getPageData1: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "06 Login/06 Login/06 Login.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;

          if (res.area_List) {
            var Signin = self.cmsRequestFunctions.pluck(
              "Sign_In_Section",
              res.area_List
            );
            self.signSection = self.cmsRequestFunctions.getAllMapData(
              Signin[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    getPageData2: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "25 Check Out/25 Check Out/25 Check Out.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;

          if (res.area_List) {
            var emptyBag = self.cmsRequestFunctions.pluck(
              "Check_Out_Section",
              res.area_List
            );
            self.empSection = self.cmsRequestFunctions.getAllMapData(
              emptyBag[0].component
            );
            var bannerArea = self.cmsRequestFunctions.pluck(
              "Banner_Section",
              res.area_List
            );
            self.bannerSection = self.cmsRequestFunctions.getAllMapData(
              bannerArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>